import React from 'react';
import { useModel } from '../../helpers/model/use_model';
import {Bubble} from './bubble.js';
import {GeoModel} from './geo-model.js';
import {useStateContext} from "../../helpers/state-context.js";



function Bubbles(props){
    const [state] = useStateContext()
    const resultSet = useModel(GeoModel, (m) => (m.getDataBubbles()), {});
    /*{
        getLocationCoords: function(){},
        hover: false,
        onHover: function(){}
    }*/
    if(resultSet.status !== GeoModel.Status.SUCCESS){
        return null;
    }
    const model = resultSet.data;

    const result = [];
    const belowMapPosition = [-0.5*props.mapSize[0]+20, 0.5*props.mapSize[1] - 50];
    let extraBubbleSize = false;

    for(const item of props.data){
        const dimension = props.dimension;
        const key = dimension + '.' + item[dimension];
        let isHover = false;
        if(model.hover){
            const dim = model.hover.dimension;
            const val = model.hover.value;
            if(dim === dimension && item[dim] === val){
                isHover = true;
            }
        }
        // (svg-pan-zoom) - When pan exists rescale bubble text, size and stroke based on the zoom
        const panZoom = (state.pan) ? state.zoom : 1
        const radius = Math.sqrt(item.percentage*40) / panZoom;

        let position = item[dimension] === null? null: model.getLocationCoords(item[dimension], dimension);
        if(position === null){
            belowMapPosition[0] += radius;
            position = belowMapPosition.slice(0);
            belowMapPosition[0] += radius + 10;
            extraBubbleSize = true;
        }

        const bubbleItem = {
            ...item,
            radius: radius,
            dimension: dimension,
            position: position,
            region: model.getItemRegion(dimension, item[dimension]),
            opacity: model.hover? (isHover? 0.8: 0.5): 0.8
        };

        if((props.state.categories.length === 1 && !props.state.categories.includes(8)) ||
                (props.state.selectedCategory && !props.state.categories.includes(8)) ||
                props.state.countryHover || item.is_active){
            result.push(<Bubble item={bubbleItem}
                                onMouseEnter={(country)=> props.onMouseEnter(country)}
                                onMouseLeave={props.onMouseLeave}
                                key={key}
                                showText={((state.countryHover !== 'EU' && state.countryHover))}
                                onHover={model.onHover}
                                onSelect={props.onSelect}
                                zoom={panZoom}
                                textStyle={{fontSize: `${1/panZoom}em`}}
            />);
        }
    }

    model.setExtraBubbleSize(extraBubbleSize);

    return <g>
        {result.map( (item) => item)}
    </g>;

}

Bubbles.defaultProps = {
    data: [],
    dimension: '',
    onSelect: function(){},
    mapSize: [0, 0]
};


export {Bubbles};
